import styled from 'styled-components';

const TopNavHamburgerButtonWrapper = styled.div`
   display: flex;
   border-left: 1px solid ${({ theme }) => theme.brandColors.darkBlue};
   margin-left: 1rem;
`;

export { TopNavHamburgerButtonWrapper };
